/** DOM attributes shared by the iframe preload pool and the inline panel. */

/** Marks a preload iframe and names the action it was created for. */
export const PRELOAD_ATTR = 'data-preload-action';

/** Holds the URL of a preload iframe that has not navigated yet (deferred hosts). */
export const PENDING_SRC_ATTR = 'data-pending-src';

/**
 * Marks a preload iframe that may only be loaded while its panel is open.
 * Closing the panel unloads it instead of reloading it hidden.
 */
export const LOAD_ON_OPEN_ATTR = 'data-load-on-open';

/** Set once a preload iframe has finished loading its current `src`. */
export const PRELOAD_LOADED_ATTR = 'data-preload-loaded';
